import React, {FC, useState} from "react";
import {Box, Tab, Tabs, Typography} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import {BasicInput} from "view/components/Form";
import {RawAttachmentFile} from "ts/api/attachmentFile";
import FlexBox from "view/components/Layout/FlexBox";
import {ISignature, SignatureType} from "@evennt-tech/api-v2-core";
import useStyles from "./styles";
import DrawSignature from "../DrawSignature";
import UploadSignature from "../UploadSignature";
import TypeSignature from "../TypeSignature";

type Props = {
  signatureToEdit?: ISignature;
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  setPaintedFile: (file: RawAttachmentFile | null) => void;
  uploadedFile: RawAttachmentFile | null;
  setUploadedFile: (file: RawAttachmentFile | null) => void;
  setTypedFile: (file: RawAttachmentFile | null) => void;
  signatureText: string;
  setSignatureText: React.Dispatch<React.SetStateAction<string>>;
  showCanvas: boolean;
  setShowCanvas: React.Dispatch<React.SetStateAction<boolean>>;
  showNotification?: boolean;
  style?: React.CSSProperties;
};

const getTabLabel = (label: string, condition: boolean) =>
  condition ? `${label} (1)` : label;

const EditModalContent: FC<Props> = ({
  signatureToEdit,
  activeTab,
  setActiveTab,
  setPaintedFile,
  uploadedFile,
  setUploadedFile,
  setTypedFile,
  signatureText,
  setSignatureText,
  showCanvas,
  setShowCanvas,
  showNotification,
  style,
}) => {
  const classes = useStyles();

  const TABS = [
    getTabLabel("Draw", signatureToEdit?.type === SignatureType.DRAWING),
    getTabLabel("Upload image", signatureToEdit?.type === SignatureType.IMAGE),
    getTabLabel("Type", signatureToEdit?.type === SignatureType.TEXT),
  ];
  const [penColor, setPenColor] = useState("black");

  const handleTabChange = (
    event: React.ChangeEvent<unknown>,
    newValue: number
  ) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabsContainer}
      >
        {TABS.map((label, index) => (
          <Tab
            id={`signature-type-${label}`}
            key={index}
            label={label}
            className={classes.tabLabel}
          />
        ))}
      </Tabs>

      <Box mt={3}>
        <Box>
          <BasicInput
            name="name"
            label="Sign by (Name and Surname)"
            className={classes.input}
          />
          <BasicInput
            name="role"
            label="Position or role"
            className={classes.input}
          />

          {activeTab === 0 && (
            <DrawSignature
              penColor={penColor}
              setPenColor={setPenColor}
              setPaintedFile={setPaintedFile}
              signatureToEdit={
                signatureToEdit?.type === SignatureType.DRAWING
                  ? signatureToEdit
                  : undefined
              }
              showCanvas={showCanvas}
              setShowCanvas={setShowCanvas}
              style={style}
            />
          )}
          {activeTab === 1 && (
            <UploadSignature
              uploadedFile={uploadedFile}
              setUploadedFile={setUploadedFile}
              signatureToEdit={
                signatureToEdit?.type === SignatureType.IMAGE
                  ? signatureToEdit
                  : undefined
              }
              showCanvas={showCanvas}
              setShowCanvas={setShowCanvas}
              style={style}
            />
          )}
          {activeTab === 2 && (
            <TypeSignature
              penColor={penColor}
              setPenColor={setPenColor}
              setTypedFile={setTypedFile}
              signatureText={signatureText}
              setSignatureText={setSignatureText}
              signatureToEdit={
                signatureToEdit?.type === SignatureType.TEXT
                  ? signatureToEdit
                  : undefined
              }
              showCanvas={showCanvas}
              setShowCanvas={setShowCanvas}
              style={style}
            />
          )}

          {showNotification && (
            <FlexBox alignCenter className={classes.infoBox}>
              <InfoIcon className={classes.infoIcon} />
              <Typography className={classes.infoText}>
                You can use Electronic Signature to sign Tasks or Certificates
                easily
              </Typography>
            </FlexBox>
          )}
        </Box>
      </Box>
    </>
  );
};

export default EditModalContent;
